import { PropsOf } from '../../types';
import connect from './connect';
import PlayBar from './PlayBar';

export type PlayBarProps = PropsOf<ReturnType<typeof connect>>;

export default connect(PlayBar);
